import { FC } from "react";
import classes from './adminActionStudents.module.scss'
import { Dropdown } from "../../../shared/ui/dropdown";
import { ChangeAllStudentsPayment } from "../../../features/changeAllStudentsPayment";
// import { NotificationPushAllStudents } from "../../../features/notificationPushAllStudents";
import { useAppSelector } from "../../../app/store/store";
import { FEATURES, hasFeature } from "../../../entities/my";

interface IProps {
    setTrigger: (trigger: boolean) => void;
    trigger: boolean;
}

export const AdminActionsStudents: FC<IProps> = ({trigger, setTrigger}) => {

    const {my} = useAppSelector(s => s.myReducer)

    return (
        <Dropdown
            title={<span className={classes.actionSign}>Действия</span>}
        >
            <section className={classes.features}>
                {/* <NotificationPushAllStudents /> */}
                {
                    hasFeature(my, FEATURES.FRONT.CHANGE_ALL_STUDENTS_PAYMENT)
                        &&
                    <section>
                        <ChangeAllStudentsPayment onSuccess={() => setTrigger(!trigger)} />
                    </section>
                }
            </section>
        </Dropdown>
    )
}
